import { render, staticRenderFns } from "./AllPSMs.vue?vue&type=template&id=b5cc45e8"
import script from "./AllPSMs.vue?vue&type=script&lang=js"
export * from "./AllPSMs.vue?vue&type=script&lang=js"
import style0 from "./AllPSMs.vue?vue&type=style&index=0&id=b5cc45e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports